import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { IUserDocument, IEmployeeNotificationSettings } from "../../models"
import { Tabs, Tab, Toggle } from "material-ui"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as loginActions from "../../actions/LoginActions"
import _ from "lodash"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import TableActionBar from "../../components/layout/TableActionBar"
import AddEmployeeNotificationSettingDialog from "./AddEmployeeNotificationSettingDialog"
import * as notifyHelper from "../../helpers/notifyHelper"
import AppStateStore from "../../stores/AppStateStore"
interface IState {
	emailNotification: boolean
	inAppPushNotification: boolean
	notifications: IEmployeeNotificationSettings[]
	selectedNotificationIndex: number
	openAddNotificationDialog: boolean
	editNotificationIndex: number
}

export default class EmployeeNotificationSetting extends React.Component<{}, IState> {
	constructor(props) {
		super(props)
		const loggedInUser = AuthenticationStore.getLoggedInUser() as IUserDocument
		this.state = {
			emailNotification: loggedInUser.NotificationSettings && loggedInUser.NotificationSettings.AllowEmailNotifications ? true : false,
			inAppPushNotification: loggedInUser.NotificationSettings && loggedInUser.NotificationSettings.AllowPushNotifications ? true : false,
			notifications: loggedInUser.NotificationSettings && loggedInUser.NotificationSettings.ScheduleNotificationSettings ? loggedInUser.NotificationSettings.ScheduleNotificationSettings : [],
			selectedNotificationIndex: null,
			openAddNotificationDialog: false,
			editNotificationIndex: null,
		}
		autobind(this)
	}

	updateLoggedInUser(successMsg: string) {
		const loggedInUser = _.cloneDeep(AuthenticationStore.getLoggedInUser())
		if (!loggedInUser.NotificationSettings) {
			loggedInUser.NotificationSettings = {
				AllowEmailNotifications: this.state.emailNotification,
				AllowPushNotifications: this.state.inAppPushNotification,
				ScheduleNotificationSettings: this.state.notifications
			}
		}
		else {
			loggedInUser.NotificationSettings.AllowEmailNotifications = this.state.emailNotification
			loggedInUser.NotificationSettings.AllowPushNotifications = this.state.inAppPushNotification
			loggedInUser.NotificationSettings.ScheduleNotificationSettings = this.state.notifications
		}
		loginActions.updateLoggedInUser(loggedInUser.Id, loggedInUser, () => AppStateStore.setProgressSnackbarContent(successMsg))
	}

	handleSelectNotification(rowNumber, colId) {
		colId === -1 ?
			this.setState({ selectedNotificationIndex: this.state.selectedNotificationIndex === rowNumber ? null : rowNumber }) :
			this.setState({ openAddNotificationDialog: true, selectedNotificationIndex: null, editNotificationIndex: rowNumber })
	}

	handleAddNotification(notification) {
		AppStateStore.setProgressSnackbarContent("loading")
		const notifications = this.state.notifications.slice()
		notifications.push(notification)
		this.setState({ notifications, openAddNotificationDialog: false, editNotificationIndex: null }, () =>
			this.updateLoggedInUser(strings.Successfully_added)
		)
	}

	handleUpdateNotification(notification: IEmployeeNotificationSettings) {
		AppStateStore.setProgressSnackbarContent("loading")
		const notifications = this.state.notifications.slice()
		notifications[this.state.editNotificationIndex] = notification
		this.setState({ notifications, openAddNotificationDialog: false, editNotificationIndex: null }, () =>
			this.updateLoggedInUser(strings.Successfully_updated)
		)
	}

	handleDeleteNotification(notificationIndex: number) {
		AppStateStore.setProgressSnackbarContent("loading")
		const notifications = this.state.notifications.slice()
		notifications.splice(notificationIndex, 1)
		this.setState({ notifications, selectedNotificationIndex: null, openAddNotificationDialog: false, editNotificationIndex: null }, () =>
			this.updateLoggedInUser(strings.Successfully_deleted)
		)
	}

	render() {
		return (
			<div style={{ margin: -16 }}>
				<Toggle
					toggled={this.state.emailNotification}
					onToggle={(e, value) => {
						AppStateStore.setProgressSnackbarContent("loading")
						this.setState({ emailNotification: value }, () => this.updateLoggedInUser(strings.Successfully_updated))
					}}
					label={strings.Email_Notifications}
					style={{ paddingLeft: 20, width: 250, marginBottom: 5, marginTop: 10 }}
				/>
				<Toggle
					toggled={this.state.inAppPushNotification}
					onToggle={(e, value) => {
						AppStateStore.setProgressSnackbarContent("loading")
						this.setState({ inAppPushNotification: value }, () => this.updateLoggedInUser(strings.Successfully_updated))
					}}
					label={strings.Inapp_Push_Notifications}
					style={{ paddingLeft: 20, width: 250, marginBottom: 10 }}
				/>
				<Tabs>
					<Tab label={strings.Personal_Notifications.toUpperCase()}>
						<FloatingActionButton
							className="fixed-add"
							style={{ top: -28, right: 20, zIndex: 998 }}
							secondary={true}
							onTouchTap={() => this.setState({ openAddNotificationDialog: true, selectedNotificationIndex: null, editNotificationIndex: null })}
						>
							<ContentAdd />
						</FloatingActionButton>
						<div style={{ paddingTop: 30 }}>
							<TableActionBar
								searchText=""
								rowSelectionCount={this.state.selectedNotificationIndex !== null ? 1 : 0}
								singleSelectedMessage={strings.Notification_Selected}
								title={""}
								titleStyle={{ fontSize: 16 }}
								bodyStyle={{ padding: 20, fontWeight: 500 }}
								onDeleteClick={() =>
									AppStateStore.setConfirmDialogContent({
										content: strings.Are_you_sure_you_want_to_delete_the_selected_notification,
										confirm: () => this.handleDeleteNotification(this.state.selectedNotificationIndex)
									})
								}
							/>
							<div style={{ maxHeight: 250, overflowY: "auto" }}>
								{this.state.notifications.length === 0 ?
									<h2 style={{ textAlign: "center", fontSize: 25, paddingBottom: 50, fontWeight: "bold" }}>
										{strings.No_Notification}
									</h2> :
									<Table onCellClick={this.handleSelectNotification}>
										<TableHeader>
											<TableRow>
												<TableHeaderColumn>{strings.Notification}</TableHeaderColumn>
												<TableHeaderColumn>{strings.Description}</TableHeaderColumn>
												<TableHeaderColumn>{strings.Notify_Method}</TableHeaderColumn>
											</TableRow>
										</TableHeader>
										<TableBody deselectOnClickaway={false}>
											{this.state.notifications.map((notification, index) =>
												<TableRow selected={this.state.selectedNotificationIndex === index} key={index}>
													<TableRowColumn>
														{notifyHelper.getEmployeeNotificationTypeName(notification.NotificationType)}
													</TableRowColumn>
													<TableRowColumn>{notification.Description}</TableRowColumn>
													<TableRowColumn>
														{notifyHelper.getNotifyMethodsName(notifyHelper.getNotifyMethods(notification.SendEmailNotifications, notification.SendPushNotifications, notification.SendSmsNotifications, notification.SendAppNotifications))}
													</TableRowColumn>
												</TableRow>
											)}
										</TableBody>
									</Table>
								}
							</div>
						</div>
					</Tab>
				</Tabs>
				{this.state.openAddNotificationDialog &&
					<AddEmployeeNotificationSettingDialog
						existingNotifications={this.state.notifications}
						editNotification={this.state.notifications[this.state.editNotificationIndex]}
						handleClose={() => this.setState({ openAddNotificationDialog: false, editNotificationIndex: null })}
						handleAdd={this.handleAddNotification}
						handleUpdate={this.handleUpdateNotification}
					/>
				}
			</div>
		)
	}
}